(function () {
  "use strict";
  if (window.__pbxI18n) return;
  window.__pbxI18n = true;

  var C = window.PBX_I18N || {};
  var SRC = "pl";
  var country = (C.country || "PL").toUpperCase();
  var available = C.countries || [];
  var assets = C.assets || {};

  /* country -> site languages (first = default) */
  var CL = {
    PL: ["pl"], DE: ["de"], AT: ["de"], CH: ["de", "fr", "it"], LI: ["de"], FR: ["fr"], BE: ["nl", "fr"], LU: ["fr", "de"],
    MC: ["fr"], ES: ["es"], AD: ["ca", "es"], IT: ["it"], SM: ["it"], VA: ["it"], NL: ["nl"], PT: ["pt"], CZ: ["cs"],
    SK: ["sk"], SE: ["sv"], AX: ["sv"], DK: ["da"], FO: ["da"], NO: ["no"], SJ: ["no"], FI: ["fi"], HU: ["hu"],
    RO: ["ro"], MD: ["ro"], BG: ["bg"], HR: ["hr"], BA: ["bs", "hr"], SI: ["sl"], GR: ["el"], CY: ["el"], LT: ["lt"],
    LV: ["lv"], EE: ["et"], UA: ["uk"], RU: ["ru"], BY: ["ru"], RS: ["sr"], ME: ["sr"], AL: ["sq"], XK: ["sq"],
    MK: ["mk"], IS: ["is"], MT: ["en", "mt"], GB: ["en"], IE: ["en"], GI: ["en"], GG: ["en"], JE: ["en"], IM: ["en"]
  };
  var LANG_CODES = "pl,en,de,fr,es,it,nl,pt,cs,sk,sv,da,no,fi,hu,ro,bg,hr,sl,el,lt,lv,et,uk,ru,sr,bs,sq,mk,is,mt,ca";

  /* every country is shown in its own language so visitors recognise it */
  var NATIVE = {
    AL: "Shqipëria", AD: "Andorra", AT: "Österreich", BE: "België · Belgique", BY: "Беларусь", BA: "Bosna i Hercegovina",
    BG: "България", HR: "Hrvatska", CY: "Κύπρος", ME: "Crna Gora", CZ: "Česko", DK: "Danmark", EE: "Eesti", FI: "Suomi",
    FR: "France", GI: "Gibraltar", GR: "Ελλάδα", GG: "Guernsey", ES: "España", NL: "Nederland", IE: "Ireland", IS: "Ísland",
    JE: "Jersey", XK: "Kosova", LI: "Liechtenstein", LT: "Lietuva", LV: "Latvija", LU: "Luxembourg", MK: "Северна Македонија",
    MT: "Malta", MD: "Moldova", MC: "Monaco", DE: "Deutschland", NO: "Norge", PL: "Polska", PT: "Portugal", RU: "Россия",
    RO: "România", SM: "San Marino", RS: "Srbija", SK: "Slovensko", SI: "Slovenija", SJ: "Svalbard og Jan Mayen",
    CH: "Schweiz · Suisse · Svizzera", SE: "Sverige", UA: "Україна", VA: "Città del Vaticano", HU: "Magyarország",
    GB: "United Kingdom", IT: "Italia", IM: "Isle of Man", AX: "Åland", FO: "Føroyar"
  };

  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };

  function previewId() {
    var t = window.Shopify && Shopify.theme;
    return t && t.role && t.role !== "main" && t.id ? String(t.id) : "";
  }
  // market changes can hop between domains (pl <-> eu): carry the language marker and, for an
  // unpublished theme, the preview id so the other domain renders this theme too
  function returnTo(cur, mark) {
    try {
      var u = new URL(cur || "/", location.origin);
      u.searchParams.delete("pbx_xl");
      u.searchParams.delete("preview_theme_id");
      if (mark) u.searchParams.set("pbx_xl", "1");
      var pid = previewId();
      if (pid) u.searchParams.set("preview_theme_id", pid);
      return u.pathname + u.search;
    } catch (e) { return cur || "/"; }
  }

  function autoLang(cc) {
    var arr = CL[cc] || ["en"];
    var nav = (navigator.languages || [navigator.language || ""]).map(function (l) { return String(l).slice(0, 2).toLowerCase(); });
    for (var i = 0; i < nav.length; i++) if (arr.indexOf(nav[i]) !== -1) return nav[i];
    return arr[0];
  }

  /* ---------- country list: native names, sorted, still searchable in Polish/English ---------- */
  function nativeCountryList() {
    var form = document.getElementById("PbxCountryForm");
    if (!form) return;
    var en = null;
    try { en = new Intl.DisplayNames(["en"], { type: "region" }); } catch (e) {}
    var items = form.querySelectorAll("a[data-value]");
    var parent = null, rows = [];
    for (var i = 0; i < items.length; i++) {
      var a = items[i], cc = String(a.getAttribute("data-value")).toUpperCase();
      var nm = NATIVE[cc];
      var span = a.querySelector(".country");
      if (!nm || !span || span.getAttribute("data-pbx-native")) continue;
      var pl = span.textContent.trim();
      var eng = "";
      try { eng = en ? en.of(cc) : ""; } catch (e) {}
      var latin = /^[\x20-ɏḀ-ỿ·]*$/.test(nm);
      span.textContent = nm + (!latin && eng ? " (" + eng + ")" : "");
      var hid = document.createElement("span");
      hid.className = "visually-hidden";
      hid.setAttribute("aria-hidden", "true");
      hid.textContent = " " + pl + " " + eng;
      span.appendChild(hid);
      span.setAttribute("data-pbx-native", "1");
      span.setAttribute("translate", "no");
      span.className += " notranslate";
      var li = a.closest("li");
      if (li) { parent = li.parentNode; rows.push({ li: li, key: nm }); }
    }
    if (parent && rows.length) {
      var coll = null;
      try { coll = new Intl.Collator("en", { sensitivity: "base" }); } catch (e) {}
      rows.sort(function (x, y) { return coll ? coll.compare(x.key, y.key) : (x.key < y.key ? -1 : 1); });
      rows.forEach(function (r) { parent.appendChild(r.li); });
    }
    var btn = form.querySelector(".disclosure__button > span");
    if (btn && NATIVE[country]) {
      var parts = btn.textContent.split("|");
      if (parts.length > 1) btn.textContent = NATIVE[country] + " |" + parts.slice(1).join("|");
      btn.setAttribute("translate", "no");
    }
  }

  /* ---------- first-party dictionary translator ---------- */
  var T = null, PATS = [], PHR = [], done = typeof WeakMap === "function" ? new WeakMap() : null;
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, IFRAME: 1, CODE: 1, PRE: 1 };

  function nk(s) {
    return s.replace(/^@/, "").replace(/\s+/g, " ").trim().toLowerCase().replace(/[.?!…:\s]+$/, "");
  }
  function lookup(raw) {
    var m = /^(\s*)([\s\S]*?)(\s*)$/.exec(raw);
    var core = m[2];
    if (!core || core.length > 900) return null;
    var v = T.d[nk(core)], i;
    if (v === undefined) {
      for (i = 0; i < PATS.length; i++) {
        var r = PATS[i][0].exec(core);
        if (r) {
          v = PATS[i][1].replace(/\$(\d)/g, function (_, n) { return r[+n] !== undefined ? r[+n] : ""; });
          break;
        }
      }
    }
    if (v === undefined && PHR.length) {
      var changed = core;
      for (i = 0; i < PHR.length; i++) if (changed.indexOf(PHR[i][0]) !== -1) changed = changed.split(PHR[i][0]).join(PHR[i][1]);
      if (changed !== core) v = changed;
    }
    return v === undefined ? null : m[1] + v + m[3];
  }
  function inSkipped(el) {
    for (var n = el; n && n.nodeType === 1; n = n.parentNode) {
      if (SKIP[n.tagName] || n.hasAttribute("data-pbx-notr") || n.getAttribute("data-pbx-native")) return true;
    }
    return false;
  }
  function doText(node) {
    var val = node.nodeValue;
    if (!val || !/\S/.test(val)) return;
    if (done && done.get(node) === val) return;
    var par = node.parentNode;
    if (!par || par.nodeType !== 1 || inSkipped(par)) return;
    var out = lookup(val);
    if (out === null || out === val) return;
    node.nodeValue = out;
    if (done) done.set(node, out);
    if (!par.firstElementChild) par.setAttribute("translate", "no");
  }
  var ATTRS = ["placeholder", "aria-label", "title", "alt"];
  function doAttrs(el) {
    if (inSkipped(el)) return;
    for (var i = 0; i < ATTRS.length; i++) {
      var v = el.getAttribute(ATTRS[i]);
      if (v && /\S/.test(v)) { var o = lookup(v); if (o !== null && o !== v) el.setAttribute(ATTRS[i], o); }
    }
    if ((el.tagName === "INPUT") && /^(submit|button)$/.test(el.type) && el.value) {
      var ov = lookup(el.value); if (ov !== null && ov !== el.value) el.value = ov;
    }
  }
  function walk(root) {
    if (!T || !root) return;
    if (root.nodeType === 3) return doText(root);
    if (root.nodeType !== 1 || SKIP[root.tagName]) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) doText(n);
    if (root.matches && root.matches("[placeholder],[aria-label],[title],[alt],input")) doAttrs(root);
    var els = root.querySelectorAll("[placeholder],[aria-label],[title],[alt],input[type=submit],input[type=button]");
    for (var i = 0; i < els.length; i++) doAttrs(els[i]);
  }
  function doTitle() {
    var parts = document.title.split(" – "), ch = false;
    for (var i = 0; i < parts.length; i++) { var o = lookup(parts[i]); if (o !== null && o !== parts[i]) { parts[i] = o.trim(); ch = true; } }
    if (ch) document.title = parts.join(" – ");
  }

  var queue = [], timer = 0;
  function flush() {
    timer = 0;
    var q = queue; queue = [];
    for (var i = 0; i < q.length; i++) walk(q[i]);
  }
  function startObserver() {
    if (!("MutationObserver" in window)) return;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === "characterData") queue.push(m.target);
        else for (var j = 0; j < m.addedNodes.length; j++) queue.push(m.addedNodes[j]);
      }
      if (!timer) timer = setTimeout(flush, 40);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function loadScript(url, cb) {
    var el = document.createElement("script");
    el.src = url;
    el.async = true;
    el.onload = cb;
    document.head.appendChild(el);
  }
  function buildDict(tr) {
    var src = window.PBX_SRC || [], d = {}, p = [], s = [];
    for (var i = 0; i < src.length; i++) {
      var e = src[i], t = tr[e[0]];
      if (t === undefined) continue;
      if (e[1] === "d") d[nk(e[2])] = t;
      else if (e[1] === "p") p.push([e[3], t.replace(/\{(\d)\}/g, function (_, n) { return "$" + (+n + 1); })]);
      else s.push([e[2], t]);
    }
    return { d: d, p: p, s: s };
  }
  function loadDictionary(lang, cb) {
    var need = 0, fin = function () {
      if (--need > 0) return;
      var tr = window.PBX_TR && window.PBX_TR[lang];
      cb(tr && window.PBX_SRC ? buildDict(tr) : null);
    };
    if (!window.PBX_SRC && assets.src) { need++; loadScript(assets.src, fin); }
    if (!(window.PBX_TR && window.PBX_TR[lang]) && assets[lang]) { need++; loadScript(assets[lang], fin); }
    if (!need) { need = 1; fin(); }
  }
  function applyDictionary(lang) {
    loadDictionary(lang, function (d) {
      if (!d) return;
      T = d;
      for (var i = 0; i < d.p.length; i++) { try { PATS.push([new RegExp(d.p[i][0], "i"), d.p[i][1]]); } catch (e) {} }
      PHR = (d.s || []).slice().sort(function (a, b) { return b[0].length - a[0].length; });
      document.documentElement.setAttribute("lang", lang);
      walk(document.body);
      doTitle();
      startObserver();
      document.documentElement.classList.add("pbx-translated");
    });
  }

  /* ---------- Google Website Translator: long-tail content only (descriptions, articles) ---------- */
  function cookieDomains() {
    var h = location.hostname, parts = h.split("."), out = ["", h, "." + h];
    if (parts.length > 2) out.push("." + parts.slice(-2).join("."));
    return out;
  }
  function setTransCookie(lang) {
    var v = "/" + SRC + "/" + lang;
    cookieDomains().forEach(function (d) {
      document.cookie = "googtrans=" + v + "; path=/" + (d ? "; domain=" + d : "");
    });
  }
  function clearTransCookie() {
    cookieDomains().forEach(function (d) {
      document.cookie = "googtrans=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/" + (d ? "; domain=" + d : "");
    });
  }
  function hasTransCookie() { return /(^|;\s*)googtrans=\/[a-z]+\/[a-z]+/.test(document.cookie); }

  var widgetLoaded = false;
  function loadWidget() {
    if (widgetLoaded) return;
    widgetLoaded = true;
    var holder = document.createElement("div");
    holder.id = "pbx-gt";
    holder.className = "notranslate";
    holder.style.display = "none";
    document.body.appendChild(holder);
    window.pbxGoogleTranslateInit = function () {
      try {
        new google.translate.TranslateElement({ pageLanguage: SRC, autoDisplay: false, includedLanguages: LANG_CODES }, "pbx-gt");
      } catch (e) {}
    };
    var s = document.createElement("script");
    s.src = "https://translate.google.com/translate_a/element.js?cb=pbxGoogleTranslateInit";
    s.async = true;
    document.head.appendChild(s);
    protectNoTranslate();
  }

  var NT = ".price,.price-item,.money,.pbx-price,.pbx-variant-price,.pbx-sg-price,.pbx-rec-price,.pbx-wd-price,.totals__total-value," +
    ".cart-item__price-wrapper,.pbx-cart-count,.pbx-vendor,.pbx-rec-brand,.pbx-sg-brand,.pbx-wd-brand,.pbx-brand-fallback,.pbx-nav-logo,.pbx-footer-logo";
  function markNoTranslate() {
    document.querySelectorAll(NT).forEach(function (el) {
      if (el.getAttribute("translate") !== "no") { el.setAttribute("translate", "no"); el.classList.add("notranslate"); }
    });
  }
  function protectNoTranslate() {
    markNoTranslate();
    if (!("MutationObserver" in window)) return;
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(markNoTranslate, 250); })
      .observe(document.body, { childList: true, subtree: true });
  }

  function whenConsented(cb, explicit) {
    if (explicit) return cb();
    var tries = 0;
    (function check() {
      var cp = window.Shopify && Shopify.customerPrivacy;
      if (!cp || typeof cp.preferencesProcessingAllowed !== "function") {
        if (tries++ < 20) return setTimeout(check, 150);
        return cb();
      }
      var needsBanner = typeof cp.shouldShowBanner === "function" ? cp.shouldShowBanner() : false;
      if (cp.preferencesProcessingAllowed() || !needsBanner) return cb();
      document.addEventListener("visitorConsentCollected", function h() {
        if (cp.preferencesProcessingAllowed()) { document.removeEventListener("visitorConsentCollected", h); cb(); }
      });
    })();
  }

  /* ---------- boot: the language always follows the selected country ---------- */
  function boot() {
    var userInit = /[?&]pbx_xl=1/.test(location.search);
    if (userInit) {
      store.set("pbx_lang_explicit", "1");
      try {
        var cu = new URL(location.href);
        cu.searchParams.delete("pbx_xl");
        history.replaceState(null, "", cu.pathname + cu.search + cu.hash);
      } catch (e) {}
    }
    store.set("pbx_country", country);
    nativeCountryList();
    var lang = autoLang(country);
    if (lang === SRC) {
      if (hasTransCookie()) { clearTransCookie(); if (/translated-/.test(document.documentElement.className)) location.reload(); }
      return;
    }
    applyDictionary(lang);
    setTransCookie(lang);
    whenConsented(loadWidget, store.get("pbx_lang_explicit") === "1");
  }

  function switchCountry(cc) {
    var form = document.getElementById("PbxCountryForm");
    var input = form && form.querySelector('input[name="country_code"]');
    if (!form || !input) return false;
    input.value = cc;
    var rt = form.querySelector('input[name="return_to"]');
    if (rt) rt.value = returnTo(rt.value, false);
    form.submit();
    return true;
  }

  function cameFromLocalizationChange() {
    // Shopify hops between market domains (pl <-> eu) after a region change; never undo that choice
    if (/[?&]lai_r=1/.test(location.search)) return true;
    try { return /(^|\.)perfumebarx\./.test(new URL(document.referrer).hostname); } catch (e) { return false; }
  }

  /* first visit only: if the visitor is physically in a country we sell to, switch to it */
  function geoOnce() {
    if (store.get("pbx_geo") === "1") return;
    store.set("pbx_geo", "1");
    if (cameFromLocalizationChange() || /[?&]pbx_xl=1/.test(location.search)) return;
    try {
      fetch("/browsing_context_suggestions.json?country[handle]=" + encodeURIComponent(country) + "&language[handle]=" + encodeURIComponent(C.locale || SRC), { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var det = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
          det = det ? String(det).toUpperCase() : null;
          if (det && det !== country && available.indexOf(det) !== -1) switchCountry(det);
        })
        .catch(function () {});
    } catch (e) {}
  }

  /* picking a country in the list: remember it was an explicit choice and carry it across domains */
  document.addEventListener("click", function (e) {
    var item = e.target.closest && e.target.closest("#PbxCountryForm a[data-value]");
    if (!item) return;
    var cc = String(item.getAttribute("data-value") || "").toUpperCase();
    if (!cc || cc === country) return;
    store.set("pbx_lang_explicit", "1");
    store.set("pbx_geo", "1");
    if (autoLang(cc) === SRC) clearTransCookie(); else setTransCookie(autoLang(cc));
    var rt = document.querySelector('#PbxCountryForm input[name="return_to"]');
    if (rt) rt.value = returnTo(rt.value, true);
  }, true);

  boot();
  geoOnce();
})();
